export default "__VITE_ASSET__pDRg2_PA__"